/** Firebase Auth hata kodlarını kullanıcı dostu Türkçe metne çevirir */
export function getAuthErrorMessage(error: unknown): string {
  if (error && typeof error === 'object' && 'code' in error) {
    const code = String((error as { code: string }).code);
    const map: Record<string, string> = {
      'auth/invalid-email': 'Geçersiz e-posta adresi.',
      'auth/user-disabled': 'Bu hesap devre dışı bırakılmış.',
      'auth/user-not-found': 'Bu e-posta ile kayıtlı kullanıcı bulunamadı.',
      'auth/wrong-password': 'Şifre hatalı.',
      'auth/invalid-credential': 'E-posta veya şifre hatalı.',
      'auth/email-already-in-use': 'Bu e-posta adresi zaten kullanılıyor.',
      'auth/weak-password': 'Şifre çok zayıf. En az 6 karakter kullanın.',
      'auth/too-many-requests': 'Çok fazla deneme yapıldı. Lütfen bir süre sonra tekrar deneyin.',
      'auth/network-request-failed': 'Ağ hatası. Bağlantınızı kontrol edin.',
      'auth/operation-not-allowed': 'Bu giriş yöntemi şu an kullanılamıyor.',
      'auth/invalid-phone-number': 'Geçersiz telefon numarası. Ülke kodu ile birlikte girin (örn. +905551234567).',
      'auth/missing-phone-number': 'Telefon numarası gerekli.',
      'auth/missing-verification-code': 'SMS kodunu girin.',
      'auth/invalid-verification-code': 'SMS kodu hatalı veya süresi dolmuş.',
      'auth/session-expired': 'Oturum süresi doldu. Tekrar kod isteyin.',
      'auth/captcha-check-failed': 'Güvenlik doğrulaması başarısız. Sayfayı yenileyip tekrar deneyin.',
      'auth/quota-exceeded': 'SMS kotası aşıldı. Daha sonra tekrar deneyin.',
    };
    if (map[code]) {
      return map[code];
    }
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return 'Bir hata oluştu. Lütfen tekrar deneyin.';
}
